var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.79988C11 5.35812 10.5523 5 10 5C9.44772 5 9 5.35812 9 5.79988V14.2001C9 14.6419 9.44772 15 10 15C10.5523 15 11 14.6419 11 14.2001V5.79988Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79988 9C5.35812 9 5 9.44772 5 10C5 10.5523 5.35812 11 5.79988 11H14.2001C14.6419 11 15 10.5523 15 10C15 9.44772 14.6419 9 14.2001 9H5.79988Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.47a9b783efea76a6b6f4ced146684847.svg";
export { ForwardRef as ReactComponent };